import { faFileAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import { getCartItems } from "../../actions/cartAction";
import { renderFormulaList } from "../../actions/formulaAction";
import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import {
  clearUnfinalizedPrescription,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import {
  setActivePatientForProfile,
  setActivePatientName,
} from "../../actions/roleAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import Loader from "../../components/Loader";
import { getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
import NotePopup from "../Patients/NotePopup";
import PendingPrescriptionWarningPopup from "./PendingPrescriptionWarningPopup";
import PrescriptionListPopup from "./PrescriptionListPopup";
import { BUCKET_NAME } from "../../constants/states";
import SoapNote from "../Patients/SoapNote";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const PatientList = ({
  forMyClinic,
  setActiveSection,
  clearPrescriptionValue,
  setPatientID,
  setPpcId,
  setPatientName,
  setPatientInstruction,
  setPharmacyInsytruction,
  setNotesOnPrescription,
  setPatientFirstName,
  setPatientLastName,
  setPatientEmail,
  setPatientPhone,
  setFullscriptId,
}) => {
  const patientList = useSelector(
    (state) => state.patient.createPrescriptionPatientList
  );
  const patientId = useSelector((state) => state.role.activePatientId);
  const prescriptionPageTabShowItems = useSelector(
    (state) => state.prescription.prescriptionPageTabShowItemList
  );
  const cartItems = useSelector((state) => state.cart.activeCartItem);
  const role = useSelector((state) => state.role.role);
  const appLoading = useSelector((state) => state.alert.appLoading);
  const [filteredList, setFilteredList] = useState([]);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [showPrescriptionList, setShowPrescriptionList] = useState(false);
  const [prescriptionRow, setPrescriptionRow] = useState();
  const [activeNoteID, setActiveNoteId] = useState(0);
  const [showSoapPopup, setShowSoapPopup] = useState(false);
  const [prescriptionId, setPrescriptionId] = useState(0);
  const [fromFullscript, setFromFullscript] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isFullscriptConnected = getUserDetail()?.fullScriptConnected;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getCreatePrescriptionPatients(() => {
        setIsLoading(false);
      })
    );
    dispatch(getCartItems(role?.val));
    return () => {
      dispatch(setActivePatientForProfile(0));
      dispatch(setActivePatientName(""));
    };
  }, [dispatch]);

  useEffect(() => {
    if (patientList) {
      // let userId = getUserDetail()?.id;
      // if (!patientId) {
      //   if (forMyClinic) {
      //     let newList = patientList.filter((x) => x.Patient_ID == userId);
      //     setFilteredList(newList);
      //   } else {
      //     let newList = patientList.filter((x) => x.Patient_ID !== userId);
      //     setFilteredList(newList);
      //   }
      // } else {
      //   setFilteredList(patientList);
      // }
      //let newList = patientList.filter((x) => x.Patient_ID !== userId);
      setFilteredList(patientList);
    }
  }, [patientList]);

  useEffect(() => {
    if (
      patientId > 0 &&
      filteredList?.length > 0 &&
      prescriptionPageTabShowItems.length < 2
    ) {
      var item = filteredList.find((x) => x.PPC_ID === patientId);
      if (!item) return;
      if (item?.Prescription_ID) {
        dispatch(clearUnfinalizedPrescription());
        dispatch(setUnfinalizedPrescriptionId(item.Prescription_ID));
        dispatch(prescriptionPageTabShowItemList([1]));
        setFromFullscript(item?.Fullscript_ID);
        setPrescriptionRow(item);
        setFullscriptId(item.Fullscript_ID ? item.Fullscript_ID : 0);
        setPpcId(item.PPC_ID);
        setPatientFirstName(item?.First_Name);
        setPatientLastName(item?.Last_Name);
        setPatientEmail(item?.Email);
        setPatientPhone(item?.Phone);
        dispatch(prescriptionPageTabShowItemList([1]));
        setPatientInstruction("");
        setPharmacyInsytruction("");
        setNotesOnPrescription("");
        clearPrescriptionValue();
        dispatch(renderFormulaList(true));
        if (item?.Fullscript_ID) {
          setTimeout(() => {
            dispatch(prescriptionPageTabShowItemList([1, 2]));
          }, 10);
          setActiveSection(1);
        } else {
          setTimeout(() => {
            dispatch(prescriptionPageTabShowItemList([1, 3]));
          }, 10);
          setActiveSection(2);
        }
      } else {
        dispatch(clearUnfinalizedPrescription());
        dispatch(setUnfinalizedPrescriptionId(0));
        clearPrescriptionValue();
        dispatch(renderFormulaList(true));
        setPatientID(item.Patient_ID);
        setPpcId(item.PPC_ID);
        setPatientName(`${item.First_Name} ${item.Last_Name}`);
        setPatientFirstName(item?.First_Name);
        setPatientLastName(item?.Last_Name);
        setPatientEmail(item?.Email);
        setPatientPhone(item?.Phone);
        setFullscriptId(item.Fullscript_ID ? item.Fullscript_ID : 0);
        if (item?.Fullscript_ID) {
          setTimeout(() => {
            dispatch(prescriptionPageTabShowItemList([1, 2]));
          }, 10);
          setActiveSection(1);
        } else {
          setTimeout(() => {
            dispatch(prescriptionPageTabShowItemList([1, 3]));
          }, 10);
          setActiveSection(2);
        }
      }
    }
  }, [filteredList]);
  const handleChange = (e) => {
    let searchTerm = e.target.value;

    let newList = patientList.filter((x) => {
      const fullName = `${x.First_Name} ${x.Last_Name}`.toLowerCase();
      const search = searchTerm.toLowerCase();

      return (
        fullName.includes(search) ||
        x.First_Name.toLowerCase().includes(search) ||
        x.Last_Name.toLowerCase().includes(search) ||
        x.Nickname?.toLowerCase().includes(search) ||
        x.Email?.toLowerCase().includes(search)
      );
    });
    setFilteredList(newList);
  };

  const setActiveNote = (id) => {
    setActiveNoteId(id);
    setShowNotePopup(true);
  };

  useEffect(() => {
    setIsLoading(appLoading);
  }, [appLoading]);

  const profileAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <button
        className="profile-icon"
        onClick={() => {
          history.push("/app/patient/info", row.PPC_ID);
        }}
      >
        <img
          src={
            row.Has_Profile_Picture
              ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${row.user_id
              }.png?${Math.random()}`
              : Avatar
          }
          alt="icon"
        />{" "}
        <span>View</span>
      </button>
    );
  };

  const columns = [
    {
      dataField: "Patient_ID",
      text: "Profile",
      sort: false,
      headerStyle: {
        width: "100px",
      },
      formatter: profileAction,
    },
    {
      dataField: "First_Name",
      text: "First Name",
      sort: true,
    },
    {
      dataField: "Last_Name",
      text: "Last Name",
      sort: true,
    },
    {
      dataField: "Nickname",
      text: "Id / nickname",
      sort: true,
    },
    {
      dataField: "Email",
      text: "Email",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <p
                style={{
                  margin: 0,
                  wordWrap: "break-word",
                  overflow: "hidden",
                }}
              >
                {row.Email}
              </p>
            </div>
          </>
        );
      },
    },
    {
      dataField: "note",
      text: "notes",
      headerStyle: {
        width: "100px",
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faFileAlt}
            size="3x"
            onClick={() => setActiveNote(row.PPC_ID)}
          />
        );
      },
    },

    {
      dataField: "action",
      text: "Prescriptions",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <div className="action-btn-wrapper row d-flex justify-content-center ml-2">
            <div className="d-flex justify-content-center flex-column">
              {row?.Prescription_ID ? (
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 200, hide: 100 }}
                  overlay={
                    <Tooltip>
                      {" "}
                      <p style={{ textAlign: "left" }}>
                        Pick up where you last left off
                      </p>
                    </Tooltip>
                  }
                >
                  <button
                    style={{ width: "126px" }}
                    className="btn-orange btn-table btn-black"
                    onClick={() => {
                      dispatch(clearUnfinalizedPrescription());
                      dispatch(
                        setUnfinalizedPrescriptionId(row.Prescription_ID)
                      );
                      dispatch(prescriptionPageTabShowItemList([1]));
                      setFromFullscript(row?.Fullscript_ID);
                      setPrescriptionRow(row);
                      setFullscriptId(
                        row.Fullscript_ID ? row.Fullscript_ID : 0
                      );
                      setPpcId(row.PPC_ID);
                      setPatientFirstName(row?.First_Name);
                      setPatientLastName(row?.Last_Name);
                      setPatientEmail(row?.Email);
                      setPatientPhone(row?.Phone);
                      dispatch(prescriptionPageTabShowItemList([1]));
                      setPatientInstruction("");
                      setPharmacyInsytruction("");
                      setNotesOnPrescription("");
                      clearPrescriptionValue();
                      dispatch(renderFormulaList(true));
                      if (prescriptionRow?.Fullscript_ID) {
                        setTimeout(() => {
                          dispatch(prescriptionPageTabShowItemList([1, 2]));
                        }, 10);
                        setActiveSection(1);
                      } else {
                        setTimeout(() => {
                          dispatch(prescriptionPageTabShowItemList([1, 3]));
                        }, 10);
                        setActiveSection(2);
                      }
                    }}
                  >
                    Continue
                  </button>
                </OverlayTrigger>
              ) : (
                <button
                  className="btn-orange btn-table "
                  onClick={() => {
                    dispatch(prescriptionPageTabShowItemList([1]));
                    dispatch(clearUnfinalizedPrescription());
                    dispatch(setUnfinalizedPrescriptionId(0));
                    clearPrescriptionValue();
                    dispatch(renderFormulaList(true));
                    setPatientID(row.Patient_ID);
                    setPpcId(row.PPC_ID);
                    setPatientName(`${row.First_Name} ${row.Last_Name}`);
                    setPatientFirstName(row?.First_Name);
                    setPatientLastName(row?.Last_Name);
                    setPatientEmail(row?.Email);
                    setPatientPhone(row?.Phone);
                    setFullscriptId(row.Fullscript_ID ? row.Fullscript_ID : 0);
                    setPatientInstruction("");
                    setPharmacyInsytruction("");
                    setNotesOnPrescription("");
                    if (row?.Fullscript_ID) {
                      setTimeout(() => {
                        dispatch(prescriptionPageTabShowItemList([1, 2]));
                      }, 10);
                      setActiveSection(1);
                    } else {
                      setTimeout(() => {
                        dispatch(prescriptionPageTabShowItemList([1, 3]));
                      }, 10);
                      setActiveSection(2);
                    }
                  }}
                >
                  Create New
                </button>
              )}
            </div>
          </div>
        );
      },
    },
  ];

  // if (isFullscriptConnected) {
  //   columns.push({
  //     dataField: "action",
  //     text: "Fullscript",
  //     formatter: (cell, row, rowIndex, formatExtraData) => {
  //       return (
  //         <div className="action-btn-wrapper row">
  //           {!row.Fullscript_ID ? (
  //             <button
  //               className="btn-orange btn-table"
  //               onClick={() => {
  //                 dispatch(prescriptionPageTabShowItemList([1]));
  //                 if (row.prescriptions) {
  //                   setFullscriptId(row.Fullscript_ID ? row.Fullscript_ID : 0);
  //                   setFromFullscript(true);
  //                   setPrescriptionRow(row);
  //                   setShowPrescriptionList(true);
  //                   setPpcId(row.PPC_ID);
  //                   setPatientFirstName(row?.First_Name);
  //                   setPatientLastName(row?.Last_Name);
  //                   setPatientEmail(row?.Email);
  //                   setPatientPhone(row?.Phone);
  //                 } else {
  //                   dispatch(clearUnfinalizedPrescription());
  //                   dispatch(setUnfinalizedPrescriptionId(0));
  //                   clearPrescriptionValue();
  //                   dispatch(renderFormulaList(true));
  //                   setActiveSection(1);
  //                   setPatientID(row.Patient_ID);
  //                   setPpcId(row.PPC_ID);
  //                   setPatientName(`${row.First_Name} ${row.Last_Name}`);
  //                   setPatientFirstName(row?.First_Name);
  //                   setPatientLastName(row?.Last_Name);
  //                   setPatientEmail(row?.Email);
  //                   setPatientPhone(row?.Phone);
  //                   setFullscriptId(row.Fullscript_ID ? row.Fullscript_ID : 0);
  //                   setPatientInstruction("");
  //                   setPharmacyInsytruction("");
  //                   setNotesOnPrescription("");
  //                   setTimeout(() => {
  //                     dispatch(prescriptionPageTabShowItemList([1, 2]));
  //                   }, 10);
  //                 }
  //               }}
  //             >
  //               Connect
  //             </button>
  //           ) : (
  //             <p className="status-connected">Connected</p>
  //           )}
  //         </div>
  //       );
  //     },
  //   });
  // }

  return (
    <div>
      {isLoading && <Loader />}
      {showNotePopup && (
        <NotePopup
          patientId={activeNoteID}
          noteList={filteredList.find((x) => x.ID == activeNoteID)?.notes}
          closePopup={() => setShowNotePopup(false)}
        />
      )}
      {showSoapPopup && (
        <SoapNote patientId={activeNoteID} setCanshowpopup={setShowSoapPopup} />
      )}
      {showPrescriptionList && (
        <PrescriptionListPopup
          cartItems={cartItems}
          prescriptionRow={prescriptionRow}
          setActiveSection={setActiveSection}
          clearPrescriptionValue={clearPrescriptionValue}
          setPatientID={setPatientID}
          setPpcId={setPpcId}
          setPatientName={setPatientName}
          setPatientFirstName={setPatientFirstName}
          setPatientLastName={setPatientLastName}
          setPatientEmail={setPatientEmail}
          setPatientPhone={setPatientPhone}
          setFullscriptId={setFullscriptId}
          closePopup={() => setShowPrescriptionList(false)}
          fromFullscript={fromFullscript}
          setPatientInstruction={setPatientInstruction}
          setPharmacyInsytruction={setPharmacyInsytruction}
          setNotesOnPrescription={setNotesOnPrescription}
        />
      )}
      {showWarningPopup && (
        <PendingPrescriptionWarningPopup
          clearPrescriptionValue={clearPrescriptionValue}
          closePopup={() => setShowWarningPopup(false)}
          prescriptionId={prescriptionId}
          setActiveSection={setActiveSection}
        />
      )}

      {patientList.length > 0 ? (
        <>
          {!forMyClinic && (
            <div className="row mt-1">
              <div className="col-md-6">
                <div className="form-group search">
                  <div>
                    <label htmlFor="search">
                      Search: (FIRSTNAME, LASTNAME, ID/NICKNAME, EMAIL)
                    </label>
                    <div className="input">
                      <input
                        name="search"
                        className="form-control"
                        id="search"
                        onChange={handleChange}
                        type="text"
                      ></input>
                    </div>
                  </div>
                  <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
                </div>
              </div>
            </div>
          )}
          <BootstrapTable
            classes="react-bootstrap-table"
            keyField="id"
            maxHeight="300px"
            columns={columns}
            data={filteredList}
            headerClasses="header-class"
          />
        </>
      ) : (
        <p className="page-desc">There are no patients at this time</p>
      )}
    </div>
  );
};

export default PatientList;
